import styled from 'styled-components';

import { Breakpoint } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { FormField } from '../../formField/formField.component';
import { RadioButton } from '../../radioButton/radioButton.component';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
`;

export const ButtonsContainer: StyledComponent<'div'> = styled.div`
  margin-top: 24px;
  margin-bottom: 34px;
`;

export const FormikForm: StyledComponent<'form'> = styled.form``;

export const FieldsRow: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;

  & + & {
    margin-top: 24px;
  }

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const StyledFormField: StyledComponent<typeof FormField> = styled(FormField)`
  width: 100%;

  & + & {
    margin-left: 12px;
  }

  @media ${Breakpoint.Mobile} {
    & + & {
      margin-left: 0;
      margin-top: 24px;
    }
  }
`;

export const StyledRadioButton: StyledComponent<typeof RadioButton> = styled(RadioButton)`
  & + & {
    margin-top: 20px;
  }
`;
